import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'
import { consts } from '@/services/utilities'

Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: '',
          meta: {
            title: 'cmsDashboard',
          },
          component: () => import('./views/dashboard/cms'),
        },
        // Management
        {
          path: '/settings/school-year',
          meta: {
            title: 'Año lectivo',
          },
          component: () => import('./views/management/years'),
        },
        {
          name: 'settingsGrades',
          path: '/settings/grades',
          meta: {
            title: 'Grados',
          },
          component: () => import('./views/management/grades'),
        },
        {
          name: 'settingsGroups',
          path: '/settings/groups',
          meta: {
            title: 'Grupos',
          },
          component: () => import('./views/management/groups'),
        },
        {
          name: 'settingsAreas',
          path: '/settings/areas',
          meta: {
            title: 'Áreas académicas',
          },
          component: () => import('./views/management/areas'),
        },
        {
          name: 'settingsLevel',
          path: '/settings/levels',
          meta: {
            title: 'Niveles de escolaridad',
          },
          component: () => import('./views/management/education-level'),
        },
        {
          name: 'settingsRange',
          path: '/settings/qualification-range',
          meta: {
            title: 'Rango de Calificación',
          },
          component: () => import('./views/management/qualification-range'),
        },
        {
          name: 'settingsSubjects',
          path: '/settings/subjects',
          meta: {
            title: 'Asignaturas',
          },
          component: () => import('./views/management/subjects'),
        },
        {
          name: 'settingsElectives',
          path: '/settings/electives',
          meta: {
            title: 'Electivas',
          },
          component: () => import('./views/management/electives'),
        },
        {
          name: 'settingsYears',
          path: '/settings/years',
          meta: {
            title: 'Año académico',
          },
          component: () => import('./views/management/years'),
        },
        {
          name: 'settingsPeriods',
          path: '/settings/periods',
          meta: {
            title: 'Periodo académico',
          },
          component: () => import('./views/management/periods'),
        },
        {
          name: 'settingsEnrollments',
          path: '/settings/enrollments',
          meta: {
            title: 'Matrículas',
          },
          component: () => import('./views/management/enrollment'),
        },
        {
          name: 'signedFileQr',
          path: '/signed-file/:idTemplateFileUser',
          props: true,
          meta: {
            title: 'Documento firmado electrónicamente',
          },
          component: () => import('./views/enrollment/signedFile'),
        },
        {
          name: 'cmsManagement',
          path: '/cms',
          meta: {
            title: 'CMS',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/management/cms'),
        },
        {
          name: 'settingsParams',
          path: '/settings/params',
          meta: {
            title: 'Parámetros',
          },
          component: () => import('./views/management/params'),
        },
        {
          name: 'settingsLoadAcademic',
          path: '/settings/groups/:idGroup/load-academic',
          meta: {
            title: 'Carga académica',
          },
          component: () => import('./views/management/load-academic'),
        },
        {
          name: 'accountsProfile',
          path: '/accounts/profile',
          meta: {
            title: 'Perfil',
          },
          component: () => import('./views/accounts/profile'),
        },
        {
          name: 'settingsProfile',
          path: '/accounts/settings',
          meta: {
            title: 'Configuración del perfil',
          },
          component: () => import('./views/accounts/settings'),
        },
        {
          name: 'SettingsCrudRoles',
          path: '/settings/roles',
          meta: {
            title: 'Roles',
          },
          component: () => import('./views/management/roles'),
        },
        {
          name: 'routes',
          path: '/routes-management',
          meta: {
            title: 'Rutas',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/routes/list'),
        },
        {
          name: 'roles',
          path: '/roles',
          meta: {
            title: 'Roles',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/roles/list'),
        },
        {
          name: 'permissions',
          path: '/permissions',
          meta: {
            title: 'Permisos',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/permissions/list'),
        },
        {
          name: 'schools',
          path: '/schools',
          meta: {
            title: 'Instituciones',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/schools/list'),
        },
        {
          name: 'schoolsCreate',
          path: '/schools/create',
          meta: {
            title: 'Crear institución',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/schools/create'),
        },
        {
          name: 'schoolsEdit',
          path: '/schools/:idSchool/edit',
          meta: {
            title: 'Editar institución',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/schools/create'),
        },
        {
          name: 'registerErrors',
          path: '/register-error',
          meta: {
            title: 'Revisión errores',
            rolesAuth: [consts.roles.SU],
          },
          component: () => import('./views/SU/registerErrors'),
        },
        {
          name: 'users',
          path: '/users',
          meta: {
            title: 'Usuarios',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO, consts.roles.ADMIN_RESTAURANTE, consts.roles.RECARGADOR, consts.roles.CAJERO],
          },
          component: () => import('./views/users/list'),
        },
        {
          name: 'usersCreate',
          path: '/users/create',
          meta: {
            title: 'Crear usuario',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO, consts.roles.ADMIN_RESTAURANTE],
          },
          component: () => import('./views/users/create'),
        },
        {
          name: 'usersEdit',
          path: '/users/:idUser/edit',
          meta: {
            title: 'Editar usuario',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO, consts.roles.ADMIN_RESTAURANTE],
          },
          component: () => import('./views/users/create'),
        },
        // Academico
        {
          name: 'clases',
          path: '/classes',
          meta: {
            title: 'Clases',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/classes/group'), // import('./views/auth/comingsoon'),
        },
        {
          name: 'descriptorBank',
          path: '/descriptors',
          meta: {
            title: 'Banco de descriptores',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE],
          },
          component: () => import('./views/descriptorBank/'), // import('./views/auth/comingsoon'),
        },
        {
          name: 'performanceIndicator',
          path: '/performance',
          meta: {
            title: 'Banco de indicadores',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE],
          },
          component: () => import('./views/performanceIndicator/'), // import('./views/auth/comingsoon'),
        },
        {
          name: 'academicReport',
          path: '/academic/reports',
          meta: {
            title: 'Reporte de periodo',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/classes/group/report'), // import('./views/auth/comingsoon'),
        },
        {
          name: 'newClassroomSBG',
          path: '/classes/newsbg/:idClass',
          props: true,
          meta: {
            title: 'Clases',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/classes/newsbg/class'), // import('./views/restaurant/sales'),
        },
        {
          name: 'classroomTBG',
          path: '/classes/tbg/:idClass',
          props: true,
          meta: {
            title: 'Clases',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/classes/tbg/class'), // import('./views/restaurant/sales'),
        },
        // Observador
        {
          path: '/viewer',
          meta: {
            title: 'Observador',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/auth/comingsoon'), // import('./views/restaurant/sales'),
        },
        {
          name: 'observationsManagement',
          path: '/observations/management',
          meta: {
            title: 'Observador',
            rolesAuth: [consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.DOCENTE, consts.roles.ADMIN_RESTAURANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/observations/list'),
        },
        {
          name: 'observationsMyReport',
          path: '/observations/my-report',
          props: true,
          meta: {
            title: 'Mi Observador',
            rolesAuth: [consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.ADMIN_RESTAURANTE, consts.roles.CAJERO, consts.roles.RECARGADOR, consts.roles.SUPERVISOR_RESTAURANTE, consts.roles.CONTADOR, consts.roles.BIBLIOTECARIO, consts.roles.FUNCIONARIO, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/observations/myReport'),
        },
        {
          name: 'observationsMyChildren',
          path: '/observations/my-children',
          props: true,
          meta: {
            title: 'Observador',
            rolesAuth: [consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/observations/myChildren'),
        },
        {
          name: 'observationsReport',
          path: '/observations/user/:idUser',
          props: true,
          meta: {
            title: 'Mi Observador',
            rolesAuth: [consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.DOCENTE, consts.roles.ADMIN_RESTAURANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/observations/reportUsers'),
        },
        {
          name: 'observationsCreate',
          path: '/observations/create/:userObserved',
          props: true,
          meta: {
            title: 'Nueva observación',
            rolesAuth: [consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.DOCENTE, consts.roles.ADMIN_RESTAURANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/observations/create'),
        },
        {
          name: 'observationsEdit',
          path: '/observations/:idObservation/edit',
          props: true,
          meta: {
            title: 'Editar observación',
            rolesAuth: [consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.ADMIN_RESTAURANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/observations/edit'),
        },
        // Restaurante
        {
          name: 'sales',
          path: '/sales',
          meta: {
            title: 'Venta',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE, consts.roles.CAJERO, consts.roles.VISITANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/sales/sales'),
        },
        {
          name: 'products',
          path: '/sales/products',
          meta: {
            title: 'Productos',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE],
          },
          component: () => import('./views/sales/products'),
        },
        {
          name: 'recharges',
          path: '/sales/recharges',
          meta: {
            title: 'Recargas',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE, consts.roles.RECARGADOR],
          },
          component: () => import('./views/sales/recharges'),
        },
        {
          name: 'salesManagement',
          path: '/sales/management',
          meta: {
            title: 'Gestión de ventas',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE, consts.roles.CAJERO, consts.roles.SUPERVISOR_RESTAURANTE],
          },
          component: () => import('./views/sales/management'),
        },
        {
          name: 'reports',
          path: '/sales/reports',
          meta: {
            title: 'Reportes de ventas',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE, consts.roles.RECARGADOR, consts.roles.SUPERVISOR_RESTAURANTE],
          },
          component: () => import('./views/sales/reports'),
        },
        {
          name: 'my-report',
          path: '/sales/my-report',
          meta: {
            title: 'Reporte personal',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_RESTAURANTE, consts.roles.RECARGADOR, consts.roles.CAJERO, consts.roles.ADMIN_ACADEMICO, consts.roles.PADRE_MADRE,
              consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.BIBLIOTECARIO, consts.roles.VISITANTE, consts.roles.FUNCIONARIO, consts.roles.SUPERVISOR_RESTAURANTE, consts.roles.PSICOLOGO],
          },
          component: () => import('./views/sales/myreport'),
        },
        {
          name: 'parentalControl',
          path: '/sales/parental-control',
          meta: {
            title: 'Control parental',
            rolesAuth: [consts.roles.PADRE_MADRE],
          },
          component: () => import('./views/sales/parentalControl'),
        },
        // Biblioteca
        {
          name: 'library',
          path: '/library',
          meta: {
            title: 'Biblioteca',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.COORDINADOR, consts.roles.GESTOR_ACADEMICO, consts.roles.DOCENTE, consts.roles.ESTUDIANTE, consts.roles.BIBLIOTECARIO],
          },
          component: () => import('./views/auth/comingsoon'),
        },
        // Contable
        {
          name: 'treasury',
          path: '/treasury',
          meta: {
            title: 'Tesorería',
            rolesAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ESTUDIANTE, consts.roles.PADRE_MADRE, consts.roles.CONTADOR],
          },
          component: () => import('./views/auth/comingsoon'),
        },
        // Nomina
        {
          name: 'managment-periods',
          path: '/payrolls/periods',
          meta: {
            title: 'Nominas',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/nomina/list'),
        },
        {
          name: 'payrollDate',
          path: '/payrolls/employees/periods',
          meta: {
            title: 'Nominas',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/nomina/list/date'),
        },
        {
          name: 'import-payroll',
          path: '/payrolls/import',
          meta: {
            title: 'Importar Nómina',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/nomina/importNominas'),
        },
        // Empleados
        {
          name: 'employees',
          path: '/employees',
          meta: {
            title: 'Empleados',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/employees/list'),
        },
        {
          name: 'create-employee',
          path: '/employees/create',
          meta: {
            title: 'Crear empleado',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/employees/create'),
        },
        {
          name: 'edit-employee',
          path: '/employees/:idEmployee/edit',
          meta: {
            title: 'Editar empleado',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/employees/create'),
        },
        {
          name: 'nomina-settings',
          path: '/payroll/settings',
          meta: {
            title: 'Configuración',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./views/nomina-module/settings'),
        },
        {
          name: 'accountant-puc',
          path: '/accountant/puc',
          meta: {
            title: 'Cuentas contables',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./components/custom/accountant/settings/puc'),
        },
        {
          name: 'accountant-cost-center',
          path: '/accountant/cost-center',
          meta: {
            title: 'Centro de costos',
            rolesAuth: [consts.roles.ADMIN, consts.roles.CONTADOR],
          },
          component: () => import('./components/custom/accountant/settings/costCenter'),
        },
        // Atendance
        {
          name: 'attendance',
          path: '/attendance',
          meta: {
            title: 'Asistencia',
            roleAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO],
          },
          component: () => import('./views/auth/attendance'),
        },
        {
          name: 'register',
          path: '/register',
          meta: {
            title: 'register',
            roleAuth: [consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO],
          },
          component: () => import('./views/auth/register'),
        },
        // // Evento
        // {
        //   name: 'closing',
        //   path: '/closing/tickets',
        //   meta: {
        //     title: 'Evento',
        //     rolesAuth: [consts.roles.ADMIN],
        //   },
        //   component: () => import('./views/closing/tickets'),
        // },
        // {
        //   name: 'closingPurchaseOrden',
        //   path: '/closing/purchase-orden/:idUser',
        //   props: true,
        //   meta: {
        //     title: 'Evento - orden de compra',
        //     rolesAuth: [consts.roles.ADMIN],
        //   },
        //   component: () => import('./views/closing/purchaseOrder'),
        // },
        // Dashboards
        {
          path: '/dashboard/alpha',
          meta: {
            title: 'Dashboard Alpha',
          },
          component: () => import('./views/dashboard/alpha'),
        },
        {
          path: '/dashboard/beta',
          meta: {
            title: 'Dashboard Beta',
          },
          component: () => import('./views/dashboard/beta'),
        },
        {
          path: '/dashboard/cms',
          meta: {
            title: 'Dashboard CMS',
          },
          component: () => import('./views/dashboard/cms'),
        },
        {
          path: '/dashboard/crypto',
          meta: {
            title: 'Dashboard Crypto',
          },
          component: () => import('./views/dashboard/crypto'),
        },
        {
          path: '/dashboard/gamma',
          meta: {
            title: 'Dashboard Gamma',
          },
          component: () => import('./views/dashboard/gamma'),
        },
        // Ecommerce
        {
          path: '/ecommerce/dashboard',
          meta: {
            title: 'Ecommerce Dashboard',
          },
          component: () => import('./views/ecommerce/dashboard'),
        },
        {
          path: '/ecommerce/orders',
          meta: {
            title: 'Ecommerce Orders',
          },
          component: () => import('./views/ecommerce/orders'),
        },
        {
          path: '/ecommerce/product-catalog',
          meta: {
            title: 'Ecommerce Product Catalog',
          },
          component: () => import('./views/ecommerce/product-catalog'),
        },
        {
          path: '/ecommerce/product-details',
          meta: {
            title: 'Ecommerce Product Details',
          },
          component: () => import('./views/ecommerce/product-details'),
        },
        {
          path: '/ecommerce/cart',
          meta: {
            title: 'Ecommerce Cart',
          },
          component: () => import('./views/ecommerce/cart'),
        },
        // Widgets
        {
          path: '/widgets/general',
          meta: {
            title: 'Widgets / General',
          },
          component: () => import('./views/widgets/general'),
        },
        {
          path: '/widgets/lists',
          meta: {
            title: 'Widgets / Lists',
          },
          component: () => import('./views/widgets/lists'),
        },
        {
          path: '/widgets/tables',
          meta: {
            title: 'Widgets / Tables',
          },
          component: () => import('./views/widgets/tables'),
        },
        {
          path: '/widgets/charts',
          meta: {
            title: 'Widgets / Charts',
          },
          component: () => import('./views/widgets/charts'),
        },
        // Apps
        {
          path: '/apps/calendar',
          meta: {
            title: 'Apps / Calendar',
          },
          component: () => import('./views/apps/calendar'),
        },
        {
          path: '/apps/digitalocean-create',
          meta: {
            title: 'Apps / DigitalOcean Create',
          },
          component: () => import('./views/apps/digitalocean-create'),
        },
        {
          path: '/apps/digitalocean-droplets',
          meta: {
            title: 'Apps / DigitalOcean Droplets',
          },
          component: () => import('./views/apps/digitalocean-droplets'),
        },
        {
          path: '/apps/gallery',
          meta: {
            title: 'Apps / Gallery',
          },
          component: () => import('./views/apps/gallery'),
        },
        {
          path: '/apps/github-discuss',
          meta: {
            title: 'Apps / GitHub Discuss',
          },
          component: () => import('./views/apps/github-discuss'),
        },
        {
          path: '/apps/github-explore',
          meta: {
            title: 'Apps / GitHub Explore',
          },
          component: () => import('./views/apps/github-explore'),
        },
        {
          path: '/apps/google-analytics',
          meta: {
            title: 'Apps / Google Analytics',
          },
          component: () => import('./views/apps/google-analytics'),
        },
        {
          path: '/apps/helpdesk-dashboard',
          meta: {
            title: 'Apps / Helpdesk Dashboard',
          },
          component: () => import('./views/apps/helpdesk-dashboard'),
        },
        {
          path: '/apps/jira-agile-board',
          meta: {
            title: 'Apps / Jira Agile Board',
          },
          component: () => import('./views/apps/jira-agile-board'),
        },
        {
          path: '/apps/jira-dashboard',
          meta: {
            title: 'Apps / Jira Dashboard',
          },
          component: () => import('./views/apps/jira-dashboard'),
        },
        {
          path: '/apps/mail',
          meta: {
            title: 'Apps / Mail',
          },
          component: () => import('./views/apps/mail'),
        },
        {
          path: '/apps/messaging',
          meta: {
            title: 'Apps / Mesagging',
          },
          component: () => import('./views/apps/messaging'),
        },
        {
          path: '/apps/profile',
          meta: {
            title: 'Apps / Profile',
          },
          component: () => import('./views/apps/profile'),
        },
        {
          path: '/apps/todoist-list',
          meta: {
            title: 'Apps / Todoist List',
          },
          component: () => import('./views/apps/todoist-list'),
        },
        {
          path: '/apps/wordpress-add',
          meta: {
            title: 'Apps / Wordpress Add',
          },
          component: () => import('./views/apps/wordpress-add'),
        },
        {
          path: '/apps/wordpress-post',
          meta: {
            title: 'Apps / Wordpress Post',
          },
          component: () => import('./views/apps/wordpress-post'),
        },
        {
          path: '/apps/wordpress-posts',
          meta: {
            title: 'Apps / Wordpress Posts',
          },
          component: () => import('./views/apps/wordpress-posts'),
        },
        // Cards
        {
          path: '/cards/basic-cards',
          meta: {
            title: 'Cards / Basic',
          },
          component: () => import('./views/cards/basic-cards'),
        },
        {
          path: '/cards/tabbed-cards',
          meta: {
            title: 'Cards / Tabbed',
          },
          component: () => import('./views/cards/tabbed-cards'),
        },
        // UI Kits
        {
          path: '/ui-kits/bootstrap',
          meta: {
            title: 'UI Kit / Bootstrap',
          },
          component: () => import('./views/ui-kits/bootstrap'),
        },
        {
          path: '/ui-kits/antd',
          meta: {
            title: 'UI Kit / Ant Design',
          },
          component: () => import('./views/ui-kits/antd'),
        },
        // Tables
        {
          path: '/tables/bootstrap',
          meta: {
            title: 'Tables / Bootstrap',
          },
          component: () => import('./views/tables/bootstrap'),
        },
        {
          path: '/tables/antd',
          meta: {
            title: 'Tables / Ant Design',
          },
          component: () => import('./views/tables/antd'),
        },
        // Charts
        {
          path: '/charts/chartistjs',
          meta: {
            title: 'Charts / Chartist.js',
          },
          component: () => import('./views/charts/chartistjs'),
        },
        {
          path: '/charts/chartjs',
          meta: {
            title: 'Charts / Chart.js',
          },
          component: () => import('./views/charts/chartjs'),
        },
        {
          path: '/charts/c3',
          meta: {
            title: 'Charts / C3 Charts',
          },
          component: () => import('./views/charts/c3'),
        },
        // Icons
        {
          path: '/icons/feather-icons',
          meta: {
            title: 'Icons / Feather',
          },
          component: () => import('./views/icons/feather-icons'),
        },
        {
          path: '/icons/fontawesome',
          meta: {
            title: 'Icons / Fontawesome',
          },
          component: () => import('./views/icons/fontawesome'),
        },
        {
          path: '/icons/linearicons-free',
          meta: {
            title: 'Icons / Linearicons Free',
          },
          component: () => import('./views/icons/linearicons-free'),
        },
        {
          path: '/icons/icomoon-free',
          meta: {
            title: 'Icons / Icomoon Free',
          },
          component: () => import('./views/icons/icomoon-free'),
        },
        // Advanced
        {
          path: '/advanced/form-examples',
          meta: {
            title: 'Advanced / Form Examples',
          },
          component: () => import('./views/advanced/form-examples'),
        },
        {
          path: '/advanced/email-templates',
          meta: {
            title: 'Advanced / Email Templates',
          },
          component: () => import('./views/advanced/email-templates'),
        },
        {
          path: '/advanced/utilities',
          meta: {
            title: 'Advanced / Utilities',
          },
          component: () => import('./views/advanced/utilities'),
        },
        {
          path: '/advanced/grid',
          meta: {
            title: 'Advanced / Grid',
          },
          component: () => import('./views/advanced/grid'),
        },
        {
          path: '/advanced/typography',
          meta: {
            title: 'Advanced / Typography',
          },
          component: () => import('./views/advanced/typography'),
        },
        {
          path: '/advanced/pricing-tables',
          meta: {
            title: 'Advanced / Pricing Tables',
          },
          component: () => import('./views/advanced/pricing-tables'),
        },
        {
          path: '/advanced/invoice',
          meta: {
            title: 'Advanced / Invoice',
          },
          component: () => import('./views/advanced/invoice'),
        },
        {
          path: '/advanced/colors',
          meta: {
            title: 'Advanced / Colors',
          },
          component: () => import('./views/advanced/colors'),
        },
      ],
    },

    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  // console.log('consts.roles.PADRE_MADRE', (consts.roles.PADRE_MADRE))
  // console.log([consts.roles.SU, consts.roles.ADMIN, consts.roles.ADMIN_ACADEMICO, consts.roles.GESTOR_ACADEMICO, consts.roles.ADMIN_RESTAURANTE, consts.roles.PADRE_MADRE].includes((consts.roles.PADRE_MADRE))) // MODIFICAR RUTAS PARA AUTORIZAR USUARIOS A LAS VISTAS
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.authorized) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath },
      })
    } else {
      if (!to.meta.rolesAuth) {
        next()
        if (to.path === '/') {
          if (store.state.user.role === consts.rolesText.CAJERO) {
            next({
              path: '/sales',
            })
          } else if (store.state.user.role === consts.rolesText.RECARGADOR || store.state.user.role === consts.rolesText.ADMIN_RESTAURANTE) {
            next({
              path: '/users',
            })
          }
        }
      } else {
        if (store.state.user.roles.some((e) => to.meta.rolesAuth.includes(e))) {
          next()
        } else { // TODO Implementar y redirigir a vista 403 forbidden
          next({
            path: '/',
          })
        }
      }
    }
  } else {
    next()
  }
})

export default router
